import translate from '@translate';
import React, { FC } from 'react';
import Grid, { GridItem } from 'src/components/Grid';
import TextField from 'src/components/TextField';
import Switch from 'src/components/Switch';
import { ReminderType } from 'src/types/reminder';
import DateTimePicker from 'src/components/DateTimePicker';
import Select, { OptionType } from 'src/components/Select';
import { FormErrorsType, OnChangeType } from '../../types/global';
import { EditKeysType } from './index';

export interface DetailPropsType {
    data: ReminderType | null;
    onChange: OnChangeType<EditKeysType>;
    editData: ReminderType;
    editErrors: FormErrorsType;
    newReminder: boolean;
    disableEdit: boolean;
    usersOptions: OptionType[];
}

const Detail: FC<DetailPropsType> = (props) => {
    return (
        <Grid>
            <GridItem cols={6}>
                <TextField
                    value={props.editData.TITLE}
                    error={props.editErrors.TITLE}
                    onChange={(value, error) => props.onChange('TITLE', value, error)}
                    name="TITLE"
                    label={translate('reminderDetail.title')}
                    fullWidth
                    required
                    multiline
                    disabled={props.disableEdit}
                />
            </GridItem>
            <GridItem cols={6}>
                <DateTimePicker
                    value={props.editData.EXECUTE_AT}
                    error={props.editErrors.EXECUTE_AT}
                    onChange={(value, error) => props.onChange('EXECUTE_AT', value, error)}
                    name={'EXECUTE_AT'}
                    label={translate('reminderDetail.executionAt')}
                    fullWidth
                    disabled={props.disableEdit}
                    type="dateTime"
                    // format="lll"
                    required
                    disablePast
                />
            </GridItem>
            <GridItem cols={12}>
                <TextField
                    value={props.editData.TEXT}
                    error={props.editErrors.TEXT}
                    onChange={(value, error) => props.onChange('TEXT', value, error)}
                    name="TEXT"
                    label={translate('reminderDetail.text')}
                    fullWidth
                    required
                    multiline
                    disabled={props.disableEdit}
                />
            </GridItem>

            <GridItem cols={6}>
                <Switch
                    value={!!props.editData.IS_PUSH_NOTIFICATION}
                    onChange={(value) => props.onChange('IS_PUSH_NOTIFICATION', value ? 1 : 0, false)}
                    disabled={props.disableEdit}
                    label={translate('reminderDetail.pushNotification')}
                />
            </GridItem>
            <GridItem cols={6}>
                <Switch
                    value={!!props.editData.IS_EMAIL_NOTIFICATION}
                    onChange={(value) => props.onChange('IS_EMAIL_NOTIFICATION', value ? 1 : 0, false)}
                    disabled={props.disableEdit}
                    label={translate('reminderDetail.emailNotification')}
                />
            </GridItem>
            <GridItem cols={12}>
                <Select
                    options={props.usersOptions}
                    value={props.editData.attendeesUsers}
                    error={props.editErrors.attendeesUsers}
                    onChange={(value, error) => props.onChange('attendeesUsers', value, error)}
                    name="attendeesUsers"
                    label={translate('reminderDetail.attendeesUsers')}
                    required
                    fullWidth
                    disabled={props.disableEdit}
                    multiple
                />
            </GridItem>
        </Grid>
    );
};

export default Detail;
